import React, { FC } from 'react';
import { Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

interface Props {
  creatorId?: string;
  creatorName?: string;
}

const CreatorLink: FC<Props> = ({ creatorId, creatorName }) => {
  if (!creatorId) {
    return null;
  }

  return (
    <>
      <Link component={RouterLink} to={`/dashboard/crm/contacts/${creatorId}`}>
        {creatorName}
      </Link>
      {`, `}
    </>
  );
};

export default CreatorLink;
